import { render, staticRenderFns } from "./Repositorio.vue?vue&type=template&id=bb7b99de&scoped=true"
import script from "./Repositorio.vue?vue&type=script&lang=js"
export * from "./Repositorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7b99de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb7b99de')) {
      api.createRecord('bb7b99de', component.options)
    } else {
      api.reload('bb7b99de', component.options)
    }
    module.hot.accept("./Repositorio.vue?vue&type=template&id=bb7b99de&scoped=true", function () {
      api.rerender('bb7b99de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/repositorio/Repositorio.vue"
export default component.exports